import React, { Fragment } from 'react';

import { SUBTYPES, TYPES } from 'envs';
import { useContextCurrentSite } from 'contexts';
import { useContextMatchParams } from 'contexts/matchParams';
import {
  NAVIGATION_MODE,
  SITES,
  CHART_TYPE,
  MASTERBAR_MODE,
  ALL_MAP_MODE
} from '../../constants';

const ModuleGeneratorHeader = () => {
  const { matchParams, setParams } = useContextMatchParams();
  const { setCurrentSite } = useContextCurrentSite();
  return (
    <>
      <h1>Generador de módulos</h1>

      <br />
      {/* <Fragment>{JSON.stringify(params)}</Fragment>; */}
      <div className="generador-filters">
        {window.location.hostname === 'localhost' && (
          <div>
            <h4>Site</h4>
            <select
              onChange={e => {
                setParams({ ...matchParams, site: e.target.value });
                setCurrentSite(e.target.value);
              }}
              value={matchParams.site}
            >
              {SITES.map(e => (
                <option value={e} key={e}>
                  {e}
                </option>
              ))}
            </select>
          </div>
        )}
        <div>
          <h4>Navegable</h4>
          <select
            onChange={e => {
              setParams({ ...matchParams, navigableMode: e.target.value });
            }}
            value={matchParams.navigableMode}
          >
            <option value={NAVIGATION_MODE.INTERNAL}>No</option>
            <option value={NAVIGATION_MODE.EXTERNAL}>Si</option>
          </select>
        </div>
        <div>
          <h4>Tipo</h4>
          <select
            onChange={e => {
              setParams({
                ...matchParams,
                type: e.target.value,
                subtype: SUBTYPES.SINGLE,
                placesId: undefined,
                placeId: undefined,
                resultPlacesId: undefined,
                community: undefined,
                currentPlace: undefined
              });
            }}
            value={matchParams.type}
          >
            <option value={TYPES.GENERAL}>General</option>
            <option value={TYPES.MUNICIPAL}>Municipal</option>
            <option value={TYPES.REGIONAL}>Regional</option>
          </select>
        </div>
        {matchParams.type === TYPES.GENERAL && (
          <div>
            <h4>Subtipo</h4>
            <select
              onChange={e => {
                setParams({
                  ...matchParams,
                  subtype: e.target.value
                });
              }}
              value={matchParams.subtype}
            >
              <option value={SUBTYPES.CONGRESS}>Congreso</option>
              <option value={SUBTYPES.SENATE}>Senado</option>
            </select>
          </div>
        )}
        <div>
          <h4>Gráficos</h4>
          <select
            onChange={e => {
              setParams({ ...matchParams, chartType: e.target.value });
            }}
            value={matchParams.chartType}
          >
            <option value={CHART_TYPE.ARC}>Arco</option>
            <option value={CHART_TYPE.BARS}>Barras</option>
          </select>
        </div>
        <div>
          <h4>Barra superior</h4>
          <select
            onChange={e => {
              setParams({ ...matchParams, showMasterBar: e.target.value });
            }}
            value={matchParams.showMasterBar}
          >
            <option value={MASTERBAR_MODE.SHOW}>Mostrar</option>
            <option value={MASTERBAR_MODE.HIDE}>Ocultar</option>
          </select>
        </div>
        {matchParams.type === TYPES.REGIONAL && (
          <div>
            <h4>Todo el mapa</h4>
            <select
              onChange={e => {
                setParams({ ...matchParams, allMap: e.target.value });
              }}
              value={matchParams.allMap}
            >
              <option value={ALL_MAP_MODE.SHOW}>Mostrar</option>
              <option value={ALL_MAP_MODE.HIDE}>Ocultar</option>
            </select>
          </div>
        )}
        <div>
          <h4>Año</h4>
          <select
            onChange={e => {
              setParams({ ...matchParams, year: e.target.value });
            }}
            value={matchParams.year}
          >
            <option value="2019">2019</option>
            <option value="2023">2023</option>
          </select>
        </div>
        <div>
          <h4>Pactos Si NO Cambiar orden</h4>
          <select
            onChange={e => {
              setParams({ ...matchParams, changeOrder: e.target.value });
            }}
            value={matchParams.changeOrder}
          >
            <option value="0">No</option>
            <option value="1">Sí</option>
          </select>
        </div>
      </div>
    </>
  );
};
export default ModuleGeneratorHeader;
